import ReactDOM from "react-dom";

const Modal = ({children}) => {
    const node = document.getElementById("Modal");

    return ReactDOM.createPortal(
        children,
        node
    );
};

export default Modal;